import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import RootState from '@/types/RootState'
import { user } from '@/store/User/store'
import { partyRoom } from '@/store/PartyRoom/store'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    error: false,
    errorMessage: '',
    user: { privateToken: '', tokenExpires: 0, hasAuthorizedSpotify: false, refreshToken: '', songsVotedFor: [] },
    partyRoom: {}
  },
  modules: {
    user,
    partyRoom
  }
}

const exportStore = new Vuex.Store<RootState>(store)

export default exportStore
